import styled from 'styled-components';
import Popover from 'components/Popover';

export const SPopover = styled(Popover)`
  max-width: 350px;
`;
